import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Presentational row for a curated external resource (app, tool, site).
 * Renders the name as a link plus a short muted description, styled as a
 * discrete row rather than inline-prose. External links (default) open in a
 * new tab with safe rel attributes.
 */
@Component({
  selector: 'app-resource-row',
  imports: [],
  templateUrl: './resource-row.component.html',
  styleUrl: './resource-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceRowComponent {
  readonly name = input.required<string>();
  readonly description = input.required<string>();
  /** Optional outbound URL. When absent the name renders as plain text. */
  readonly href = input<string>();
  /** External links open in a new tab with rel="noopener noreferrer". */
  readonly external = input<boolean>(true);
}
